import React, { Component } from 'react'

function Footer() {
      const currentYear = new Date().getFullYear();

    return (
       
                <footer className="footer">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-sm-6">
                                 © Systech Technologies {currentYear}
                            </div>
                            <div className="col-sm-6">
                                
                            </div>
                        </div>
                    </div>
                </footer>

        );
    }
export default Footer;
